
const AppPlanInput = {
  "name": "AppPlanInput",
  "kind": "INPUT_OBJECT",
  "inputFieldBaseTypes": {
    "appUsagePricingDetails": "AppUsagePricingInput",
    "appRecurringPricingDetails": "AppRecurringPricingInput"
  }
};
export default AppPlanInput;